export class ConstructionUpdates {
  public IsApproved: Boolean;
  public Reason: string;
  public Status: number;
  public CustomerName :string;
}
